import { render } from "./CartAddressSelector.vue?vue&type=template&id=145ef788&lang=pug"
import script from "./CartAddressSelector.vue?vue&type=script&lang=js"
export * from "./CartAddressSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__